import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-child-awb',
    templateUrl: './child-awb.component.html',
    styleUrls: ['./child-awb.component.scss']
})

export class ChildAWBGridComponent implements OnInit, AfterViewInit {

    awbInscanForm: FormGroup;
    @Input() childAWBNoList: any[];
    @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
    @ViewChild('saveBtn') saveButton!: ElementRef;

    isFormSubmitted = false;
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;

    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: true,
    };
    rowData = [];

    gridOptions: GridOptions = {
        rowSelection: 'multiple',
        pagination: true,
        paginationPageSize: 10,
        domLayout: 'autoHeight',
    };

    columnDefs = [
        { headerName: 'Child AWB No.', field: 'childawb', checkboxSelection: true, headerCheckboxSelection: true, minWidth: 450 }
    ]
    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private awbService: AWBService
    ) { }

    ngOnInit() {
        // console.log('from model childAWBNoList', this.childAWBNoList);
        this.bindChildAWBList()
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.agGrid.api) {
                this.agGrid.api.ensureIndexVisible(0); // Ensure the first row is visible
                this.agGrid.api.setFocusedCell(0, 'childawb'); // Focus on the first row
            }
        }, 500);
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            if (this.agGrid.api.getSelectedRows().length > 0) {
                // Move focus to Save button if a row is selected
                setTimeout(() => {
                    this.saveButton.nativeElement.focus();
                }, 200);
            } else {
                // Otherwise, focus on the first row
                setTimeout(() => {
                    this.agGrid.api.setFocusedCell(0, 'childawb');
                }, 200);
            }
        }
    }

    bindChildAWBList() {
        this.rowData = this.childAWBNoList.map((element, index) => ({
            id: index + 1,
            childawb: element.awbnumber
        }));
    }

    async onSaveClick() {
        const rows = this.gridOptions.api.getSelectedRows().flatMap(x => (x.childawb));
        // console.log('rows',rows);
        this.activeModal.close(rows);
    }

    async openConfirmationDialog(reqObj: any) {
        const result = await Swal.fire({
            title: 'Confirmation',
            html: '<span>This is a <b>Misroute</b> shipment.</span><br><span>Do you still want to receive it ?</sapn>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            //if user wants to receive shipment --> two TRANSACTION_STATUS insert : SHIPMENT_MISROUTED
            // reqObj.misroute = true;
            // this.proceedWithAwbInscan(reqObj);
        }
    }

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.setDomLayout("autoHeight");
    }

}
